<template>
    <v-chip variant="flat" density="comfortable" class="font-weight-bold">
      {{ labelName }}
    </v-chip>
</template>

<script>
/**
 * Default Project label
 * @displayName AppProjectLabel
 */
export default {
  name: 'AppProjectLabel',
  props: {
    /**
     * Label Object
     *{
     *  color: String (Vuetify color or hex #000000),
     *  id: Number,
     *  label: {
     *    fr: String,
     *    en: String,
     *    ...,
     *  },
     *  order: Number,
     *  subscriptionId: Number,
     * }
     */
    label: {
      type: Object,
      required: true,
    },
  },
  computed: {
    labelName () {
      return this.label.label[this.$i18n.locale]
    },
    chipColor () {
      return this.label.color
    },
    chipTextColor () {
      return this.label.color.toUpperCase() === '#F2B21D' ? 'rgb(var(--v-theme-text-warning))' : 'rgb(var(--v-theme-text-inverted))'
    },
  },
}
</script>

<style lang="scss" scoped>
.v-chip {
  background: v-bind(chipColor);
  color: v-bind(chipTextColor);
}
</style>

<!--<docs>-->
<!--```vue-->
<!--<template>-->
<!--  <div>-->
<!--    <AppProjectLabel :label="label"/>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--  export default {-->
<!--    data () {-->
<!--      return {-->
<!--        label: {-->
<!--          color:"#00ff00",-->
<!--          id:2,-->
<!--          label: {-->
<!--            en:"Started",-->
<!--            fr:"Démarré",-->
<!--          },-->
<!--          order:0,-->
<!--          subscriptionId:1,-->
<!--        }-->
<!--      }-->
<!--    },-->
<!--  }-->
<!--</script>-->
<!--```-->
<!--</docs>-->
